// extracted by mini-css-extract-plugin
export default {"tableWrapper":"SupplyTable_tableWrapper__HC2Xl","total":"SupplyTable_total__g6yx5","rarity":"SupplyTable_rarity__S7NJ2","digits":"SupplyTable_digits__Rzpjj"};